import { render, staticRenderFns } from "./ChangeStatusModal.vue?vue&type=template&id=b32c9c64&scoped=true&"
import script from "./ChangeStatusModal.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusModal.vue?vue&type=style&index=0&id=b32c9c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32c9c64",
  null
  
)

export default component.exports